import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';
import { SchedulesFacade } from '@mode/dataset/domain';
import { DatasetFacade } from '@mode/dataset/contract';

export const DowngradedDatasetDomainModule = angular
  .module('downgraded-dataset-domain', [])
  .service('DatasetFacade', downgradeInjectable(DatasetFacade))
  .service('DatasetSchedulesFacade', downgradeInjectable(SchedulesFacade)).name;
